import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import ImageToIco from '../../components/ImageToIco';

const IcoPage: React.FC = () => (
  <ToolLayout
    title="Image to ICO Converter - Create Icon Files | AllTools"
    description="Convert images to ICO icon format. Generate multiple sizes for favicons and app icons. Free converter."
    canonicalPath="/image-to-ico"
  >
    <ImageToIco />
  </ToolLayout>
);

export default IcoPage;
